/**
 * SurfaceEffector2D Component
 *
 * Applies tangential force to bodies touching the surface (conveyor belts).
 * Requires a Collider2D on the same GameObject.
 */

import {
  component,
  displayName,
  icon,
  color,
  category,
  allowMultiple,
  requireComponent,
  field,
} from "../attributes";

@component("core.SurfaceEffector2D")
@displayName("Surface Effector 2D")
@icon("ArrowRightLeft")
@color("#e67e22")
@category("Physics 2D")
@allowMultiple(false)
@requireComponent(["core.Transform", "core.Collider2D"])
export class SurfaceEffector2D {
  /** Surface speed - positive moves right, negative moves left */
  @field({ type: "f32", label: "Speed", step: 0.5 })
  speed: number = 5.0;

  /** Speed variation (random ±variation) */
  @field({ type: "f32", label: "Speed Variation", min: 0, step: 0.1 })
  speedVariation: number = 0;

  /** Force scale - how strongly bodies are pushed */
  @field({ type: "f32", label: "Force Scale", min: 0, step: 0.1 })
  forceScale: number = 1.0;

  /** Use contact normal - apply force along contact surface direction */
  @field({ type: "bool", label: "Use Contact Normal" })
  useContactNormal: boolean = true;

  /** Use friction - whether to apply surface friction */
  @field({ type: "bool", label: "Use Friction" })
  useFriction: boolean = true;

  /** Use bounce - whether to apply surface bounciness */
  @field({ type: "bool", label: "Use Bounce" })
  useBounce: boolean = true;
}
